/**
 * Session tracking beacon — sends heartbeat every 30s while user is active.
 * Tracks: session duration, pages visited, active time.
 */
const API = process.env.REACT_APP_BACKEND_URL;
let sessionId = null;
let lastPath = '';
let heartbeatTimer = null;
let isVisible = true;

function getSessionId() {
  if (!sessionId) {
    sessionId = sessionStorage.getItem('sendpi_sid');
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem('sendpi_sid', sessionId);
    }
  }
  return sessionId;
}

async function sendBeacon(eventType, extra = {}) {
  try {
    const payload = {
      sid: getSessionId(),
      event: eventType,
      path: window.location.pathname,
      referrer: document.referrer?.slice(0, 500) || '',
      screen_w: window.screen?.width || 0,
      screen_h: window.screen?.height || 0,
      ...extra,
    };
    // Use sendBeacon for reliability (doesn't block page unload)
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/beacon`, JSON.stringify(payload));
    } else {
      fetch(`${API}/api/beacon`, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' }, keepalive: true });
    }
  } catch { /* silent */ }
}

function startHeartbeat() {
  if (heartbeatTimer) return;
  heartbeatTimer = setInterval(() => {
    if (isVisible) sendBeacon('heartbeat');
  }, 30000);
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}

export function initSessionTracking() {
  // Page view on load
  sendBeacon('pageview');
  lastPath = window.location.pathname;
  startHeartbeat();

  // Track visibility
  document.addEventListener('visibilitychange', () => {
    isVisible = !document.hidden;
    if (isVisible) {
      sendBeacon('focus');
      startHeartbeat();
    } else {
      sendBeacon('blur');
      stopHeartbeat();
    }
  });

  // Track page unload
  window.addEventListener('beforeunload', () => {
    sendBeacon('leave');
  });
}

// Call on route changes (React Router)
export function trackPageChange(path) {
  if (path !== lastPath) {
    lastPath = path;
    sendBeacon('pageview');
  }
}
